<template lang="html">
  <el-dialog
    title="查看地址"
    :visible="dialogVisible"
    :close-on-click-modal="false"
    style="padding: 50px;"
    append-to-body
    @close="close"
  >
    <el-row type="flex" class="row-bg">
      <el-col :span="24">
        <div id="allmap" v-if="dialogVisible"></div>
      </el-col>
    </el-row>
    <span slot="footer"></span>
  </el-dialog>
</template>
<script>
export default {
  name: "seeAddress",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    addressObj: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      map: {},
      localAddressObj: {}
    };
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("update:dialogVisible", false);
    },
    iniMap() {
      // 初始化地图
      let _this = this;
      // 创建地图
      _this.map = new BMap.Map("allmap");
      // 添加缩略地图控件
      // self.map.addControl(new BMap.OverviewMapControl({offset: new BMap.Size(150, 5)}))
      // 添加地图缩放控件
      _this.map.addControl(
        new BMap.NavigationControl({ type: BMAP_NAVIGATION_CONTROL_SMALL })
      );
      // 开启鼠标滚轮缩放
      _this.map.enableScrollWheelZoom(true);
      // 添加地址
      let { name, location } = this.localAddressObj;
      let lonLat = location.split(",");
      let addressPoint = new BMap.Point(
        parseFloat(lonLat[0]),
        parseFloat(lonLat[1])
      );
      let marker = new BMap.Marker(addressPoint);
      _this.map.centerAndZoom(addressPoint, 15);
      // 添加标注
      _this.map.addOverlay(marker);
      let slabel = new BMap.Label(name, { offset: new BMap.Size(15, -20) });
      marker.setLabel(slabel);
    }
  },
  watch: {
    dialogVisible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.localAddressObj = this.addressObj;
          this.iniMap();
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-dialog__body {
  height: 500px;
}
#allmap {
  width: 100%;
  height: 418px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/personal/deliver/components/handlingWrapper/components/seeAddressDialog/index.vue